import { cn } from "@/lib/utils"

interface ModernLoaderProps {
  className?: string;
}

export function ModernLoader({ className }: ModernLoaderProps) {
  return (
    <div className={cn("flex items-center justify-center w-full", className)}>
      <div className="w-32 h-1 bg-muted rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-primary via-primary/80 to-primary animate-[slide_1.5s_ease-in-out_infinite] w-1/2"></div>
      </div>
    </div>
  );
}
